module.exports = __webpack_public_path__ + "img/landing-title-1.b69ad6ad.svg";